import script from "./HighlightsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HighlightsPage.vue?vue&type=script&lang=ts&setup=true"

import "./HighlightsPage.vue?vue&type=style&index=0&id=28f9e192&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28f9e192"]])

export default __exports__